const attrs = 'viewBox="0 0 24 24" aria-hidden="true" focusable="false"';

export const icons = {
  sound: `<svg ${attrs}><path d="M5 9v6h4l5 4V5L9 9H5Z"/><path d="M17 9.5c1.5 1.4 1.5 3.6 0 5"/></svg>`,
  muted: `<svg ${attrs}><path d="M5 9v6h4l5 4V5L9 9H5Z"/><path d="m17 10 5 5m0-5-5 5"/></svg>`,
  pause: `<svg ${attrs}><path d="M8 5v14M16 5v14"/></svg>`,
  help: `<svg ${attrs}><circle cx="12" cy="12" r="9"/><path d="M9.7 9a2.5 2.5 0 0 1 4.8 1c0 2-2.5 2-2.5 4M12 17.5h.01"/></svg>`,
  download: `<svg ${attrs}><path d="M12 3v12m-4-4 4 4 4-4M5 19h14"/></svg>`,
} as const;
